import Vue from 'vue'
import Vuex from 'vuex'
import axios from '../config/axios'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    products: [],
    productsByCategory: [],
    carts: [],
    totalCarts: 0,
    user: localStorage.emailLogin,
    totalCash: 0
  },
  mutations: {
    setAllProducts (state, payload) {
      state.products = payload
    },
    setProducts (state, payload) {
      state.productsByCategory = payload
    },
    setAllCarts (state, payload) {
      state.carts = payload
    },
    setTotalCarts (state, num) {
      state.totalCarts = num
    },
    setUser (state, _) {
      state.user = localStorage.emailLogin
    },
    setUserNull (state, _) {
      state.user = null
    },
    setTotalCash (state, cash) {
      state.totalCash = cash
    }
  },
  actions: {
    register (context, payload) {
      const { email, password } = payload
      axios
        .post('/register', {
          email, password
        })
        .then(({ data }) => {
          router.push({ name: 'Login' })
          Vue.swal({
            position: 'bottom',
            icon: 'success',
            title: 'Register Successfully!',
            showConfirmButton: false,
            timer: 1500
          })
        })
        .catch(() => {
          Vue.swal({
            position: 'bottom',
            icon: 'error',
            title: 'Please Try Again!',
            showConfirmButton: false,
            timer: 1500
          })
        })
    },
    login (context, payload) {
      const { email, password } = payload
      axios
        .post('/login', {
          email, password
        })
        .then(({ data }) => {
          localStorage.setItem('access_token', data.token)
          localStorage.setItem('emailLogin', email)
          context.commit('setUser')
          context.dispatch('fetchAllProducts')
          router.push({ name: 'Home' })
        })
        .catch(() => {
          Vue.swal({
            position: 'center',
            icon: 'error',
            title: 'Please Try Again!',
            showConfirmButton: false,
            timer: 1500
          })
        })
    },
    logout ({ commit }) {
      localStorage.clear()
      commit('setUserNull')
      router.push({ name: 'Login' })
    },
    fetchAllProducts ({ commit }) {
      axios
        .get('/')
        .then(({ data }) => {
          commit('setAllProducts', data.listOfProduct)
        })
        .catch(console.log)
    },
    addToCart ({ dispatch }, ProdId) {
      console.log(ProdId, '<<< ProdId di Store')
      axios
        .post(`/cart/${ProdId}`, {}, {
          headers: {
            access_token: localStorage.access_token
          }
        })
        .then(({ data }) => {
          console.log(data, '<<< success add to cart')
          dispatch('fetchAllCarts')
        })
        .catch(console.log)
    },
    fetchAllCarts ({ commit }) {
      axios
        .get('/cart', {
          headers: {
            access_token: localStorage.access_token
          }
        })
        .then(({ data }) => {
          commit('setAllCarts', data.carts)
          let num = 0
          data.carts.forEach(cart => {
            num += cart.qty
          })
          commit('setTotalCarts', num)
        })
        .catch(console.log)
    },
    delCartByIdProd ({ dispatch }, prodId) {
      axios
        .delete(`/cart/${prodId}`, {
          headers: {
            access_token: localStorage.access_token
          }
        })
        .then(({ data }) => {
          console.log(data, '<<< success delete cart')
          dispatch('fetchAllCarts')
        })
        .catch(console.log)
    },
    updateQty ({ dispatch }, payload) {
      const { value, IdProd } = payload
      axios
        .put(`/cart/${IdProd}`, { value }, {
          headers: {
            access_token: localStorage.access_token
          }
        })
        .then(({ data }) => {
          // console.log(data, '<<< success edit cart')
          dispatch('fetchAllCarts')
        })
        .catch(console.log)
    },
    getProdByCategory ({ commit }, item) {
      axios
        .get('/bycategory', {
          params: {
            category: item
          }
        })
        .then(({ data }) => {
          console.log(data.products, `<<< data category ${item}`)
          commit('setProducts', data.products)
          router.push({ name: 'ByCategory' })
        })
        .catch(console.log)
    },
    checkout ({ dispatch }, payload) {
      axios
        .put('/checkout', { payload }, {
          headers: {
            access_token: localStorage.access_token
          }
        })
        .then(({ data }) => {
          dispatch('fetchAllProducts')
          dispatch('clearCart')
        })
        .catch(console.log)
    },
    clearCart ({ dispatch }) {
      axios
        .delete('/cart', {
          headers: {
            access_token: localStorage.access_token
          }
        })
        .then(({ data }) => {
          dispatch('fetchAllCarts')
        })
        .catch(console.log)
    }
  },
  modules: {
  }
})
